import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaBookOpen,
  FaBullhorn,
  FaCheckCircle,
  FaChevronDown,
  FaChevronUp,
  FaClipboardList,
  FaCreditCard,
  FaExclamationTriangle,
  FaFileInvoice,
  FaFileInvoiceDollar,
  FaHeadset,
  FaHome,
  FaInfoCircle,
  FaMoneyBillWave,
  FaReceipt,
  FaSearch,
  FaShoppingBag,
  FaUndo,
  FaUser,
  FaChartLine,
  FaShieldAlt,
} from "react-icons/fa";
import DashboardLayout from "./DashboardLayout";

const GUIDE_SECTIONS = [
  {
    id: "home",
    title: "صفحه اصلی",
    icon: FaHome,
    summary: "صفحه اصلی نقطه شروع دسترسی به تمام امکانات پنل است.",
    bullets: [
      "هر کارت اصلی شما را مستقیماً به همان بخش هدایت می‌کند؛ برای مثال «فاکتورها»، «مالی» یا «گزارش خرید». ",
      "برای استفاده راحت‌تر، ابتدا بخش موردنظر را از همین صفحه انتخاب کنید و سپس از دکمه «بازگشت» همان صفحه برای برگشت استفاده کنید.",
      "اطلاعات بالای صفحه شامل نام مشتری، کد مشتری و طبقه مشتری است و از منوی کاربر می‌توانید از حساب خارج شوید یا رمز عبور را تغییر دهید.",
    ],
    tips: ["برای شروع کار، بهتر است ابتدا «اطلاعات مشتری» را بررسی کنید تا اطلاعات ثبت‌شده و آدرس‌ها را ببینید."],
  },
  {
    id: "customer-info",
    title: "اطلاعات مشتری",
    icon: FaUser,
    summary: "اطلاعات پایه مشتری، اطلاعات تماس، گروه‌بندی و موقعیت جغرافیایی را مشاهده می‌کنید.",
    bullets: [
      "نام، کد مشتری، شماره موبایل، تلفن، نام فروشگاه، استان و شهر نمایش داده می‌شود.",
      "اگر چند آدرس برای مشتری ثبت شده باشد، آدرس‌های ثبت‌شده نیز نمایش داده می‌شوند و آدرس اصلی روی نقشه مشخص می‌شود.",
      "در بخش «گروهبندی مشتری» لایه‌های مختلف گروه‌بندی نمایش داده می‌شوند.",
      "در صورت ثبت نشدن مختصات جغرافیایی، نقشه نمایش داده نمی‌شود و پیام مربوط به نبود موقعیت نشان داده خواهد شد.",
    ],
    tips: ["این صفحه برای کنترل صحت اطلاعات ثبت‌شده بسیار مناسب است؛ در صورت مشاهده اطلاعات نادرست، از مسیرهای ارتباطی اعلام‌شده با پشتیبانی تماس بگیرید."],
  },
  {
    id: "invoices",
    title: "فاکتورها",
    icon: FaFileInvoice,
    summary: "فهرست فاکتورها، حواله‌های باز، وضعیت تسویه و امکان پرداخت آنلاین در این صفحه قرار دارد.",
    bullets: [
      "در ورود اولیه، فاکتورهای ۷ روز اخیر نمایش داده می‌شوند.",
      "برای مشاهده فاکتورهای قدیمی‌تر، تاریخ «از» و «تا» را انتخاب کرده و حتماً روی «اعمال فیلتر» بزنید.",
      "گزارش فاکتور حداکثر تا ۶۰ روز گذشته قابل دریافت است.",
      "شماره فاکتور قابل کلیک است و با انتخاب آن وارد جزئیات همان فاکتور می‌شوید.",
      "حواله‌های باز نیز در همین صفحه نمایش داده می‌شوند و با انتخاب شماره حواله می‌توانید جزئیات آن را ببینید.",
      "اگر برای یک فاکتور امکان پرداخت آنلاین فعال باشد، دکمه پرداخت در همان ردیف نمایش داده می‌شود.",
    ],
    tips: [
      "برای دیدن بازه تاریخی دلخواه، صرفاً انتخاب تاریخ کافی نیست و باید «اعمال فیلتر» را بزنید.",
      "پرداخت هر فاکتور باید جداگانه انجام شود؛ مبلغ پرداخت مربوط به همان فاکتور است.",
      "بعد از شروع پرداخت، ممکن است وضعیت فاکتور تا زمان ثبت نهایی نتیجه در سیستم «در حال تسویه» باقی بماند.",
    ],
    warning: "اگر مبلغ از حساب شما کسر شده ولی وضعیت فاکتور هنوز تغییر نکرده است، از پرداخت مجدد همان فاکتور خودداری کنید تا نتیجه پرداخت در سیستم ثبت شود.",
  },
  {
    id: "invoice-details",
    title: "جزئیات فاکتور",
    icon: FaReceipt,
    summary: "با انتخاب شماره فاکتور، اقلام و جمع مبالغ همان فاکتور را مشاهده می‌کنید.",
    bullets: [
      "برای بررسی دقیق مبلغ و اقلام خرید، شماره فاکتور را از فهرست فاکتورها انتخاب کنید.",
      "اطلاعات کلی فاکتور و جدول اقلام در این صفحه نمایش داده می‌شود.",
      "پس از بررسی جزئیات، با دکمه «بازگشت» به فهرست فاکتورها برگردید.",
    ],
    tips: ["برای مقایسه مبلغ فاکتور با پرداخت، ابتدا مبلغ «مانده تسویه نشده» را در فهرست فاکتورها بررسی کنید."],
  },
  {
    id: "financial",
    title: "مالی",
    icon: FaMoneyBillWave,
    summary: "نمای کلی وضعیت بدهی، فاکتورهای تسویه‌نشده، چک‌ها و سوابق پرداخت در این بخش قرار دارد.",
    bullets: [
      "کارت‌های آماری مانند کل بدهی، تعداد و مبلغ فاکتورهای تسویه‌نشده و وضعیت چک‌ها برای مشاهده سریع اطلاعات مالی استفاده می‌شوند.",
      "چهار بخش به‌صورت تعاملی قابل کلیک هستند و در کارت آن‌ها عبارت «مشاهده» دیده می‌شود: «واریزی‌های ثبت نشده»، «لیست چک‌های وصول‌نشده»، «لیست فاکتورهای تسویه‌نشده» و «سوابق پرداخت آنلاین». ",
      "برای دیدن جزئیات، روی خود کارت یا عبارت «مشاهده» کلیک کنید.",
      "کارت‌هایی که فقط مقدار عددی نمایش می‌دهند، برای مشاهده وضعیت هستند و لزوماً قابل کلیک نیستند.",
    ],
    tips: ["اگر می‌خواهید بفهمید بدهی شما از چه بخش‌هایی تشکیل شده است، از کارت‌های قابل کلیک پایین صفحه شروع کنید."],
  },
  {
    id: "unsettled-invoices",
    title: "فاکتورهای تسویه‌نشده",
    icon: FaFileInvoiceDollar,
    summary: "فهرست فاکتورهایی که هنوز مانده تسویه دارند در این بخش قابل بررسی و پرداخت است.",
    bullets: [
      "فهرست فاکتورهای دارای مانده تسویه‌نشده نمایش داده می‌شود.",
      "برای پرداخت، فاکتور موردنظر را انتخاب کنید و پرداخت همان فاکتور را انجام دهید.",
      "وضعیت پرداخت هر فاکتور را می‌توان در همان فهرست پیگیری کرد.",
      "پس از بازگشت از درگاه، نتیجه پرداخت نمایش داده می‌شود و ثبت نهایی وضعیت در سیستم ممکن است کمی زمان ببرد.",
    ],
    warning: "پرداخت یک فاکتور به معنای تسویه خودکار همه فاکتورهای دیگر نیست؛ هر فاکتور جداگانه محاسبه و پرداخت می‌شود.",
  },
  {
    id: "receivable-notes",
    title: "چک‌های وصول‌نشده",
    icon: FaClipboardList,
    summary: "چک‌های وصول‌نشده و جزئیات آن‌ها از این بخش قابل مشاهده است.",
    bullets: [
      "از صفحه مالی، روی «لیست چک‌های وصول‌نشده» کلیک کنید.",
      "فهرست چک‌ها شامل اطلاعات اصلی هر چک است و برای بررسی جزئیات می‌توانید ردیف مربوط را انتخاب کنید.",
      "در صورت وجود صفحه‌بندی، با دکمه‌های پایین جدول بین صفحات جابه‌جا شوید.",
    ],
    tips: ["برای بررسی وضعیت کلی تعهدات، این صفحه را در کنار کارت‌های «بدهی چک‌های وصول‌نشده» و «بدهی چک‌های سررسید شده» در صفحه مالی ببینید."],
  },
  {
    id: "unregistered-payments",
    title: "واریزی‌های ثبت نشده",
    icon: FaCreditCard,
    summary: "واریزی‌هایی که هنوز در سیستم مالی تحلیل یا ثبت نهایی نشده‌اند در این بخش دیده می‌شوند.",
    bullets: [
      "از صفحه مالی روی کارت «واریزی‌های ثبت نشده» کلیک کنید.",
      "این بخش برای پیگیری مبالغی است که هنوز نتیجه ثبت یا تحلیل آن‌ها در سیستم نهایی نشده است.",
      "در صورت وجود جزئیات بیشتر، ردیف یا گزینه مشاهده مربوط به واریزی را انتخاب کنید.",
    ],
    tips: ["وجود واریزی در این فهرست به معنی نادیده گرفته شدن مبلغ نیست؛ ممکن است ثبت آن هنوز در چرخه پردازش مالی باشد."],
  },
  {
    id: "payment-history",
    title: "سوابق پرداخت آنلاین",
    icon: FaCheckCircle,
    summary: "تمام پرداخت‌های آنلاین ثبت‌شده و جزئیات آن‌ها از این بخش قابل پیگیری است.",
    bullets: [
      "از صفحه مالی روی «سوابق پرداخت آنلاین» کلیک کنید.",
      "می‌توانید بر اساس شماره فاکتور و بازه تاریخ جستجو و فیلتر کنید.",
      "بعد از انتخاب معیارها، برای اعمال نتیجه روی «اعمال فیلتر» بزنید و برای حذف آن‌ها «حذف فیلتر» را انتخاب کنید.",
      "برای یک پرداخت می‌توانید «مشاهده جزئیات» را انتخاب کنید تا اطلاعات کامل‌تر همان تراکنش نمایش داده شود.",
    ],
    tips: ["اگر یک تراکنش را پیدا نمی‌کنید، ابتدا شماره فاکتور و بازه تاریخ را دقیق کنترل کنید و سپس فیلتر را اعمال کنید."],
  },
  {
    id: "return-invoices",
    title: "فاکتور برگشتی",
    icon: FaUndo,
    summary: "فهرست فاکتورهای برگشتی و جزئیات اقلام هر فاکتور در این بخش قابل مشاهده است.",
    bullets: [
      "فهرست فاکتورهای برگشتی را مشاهده کنید و در صورت نیاز بازه تاریخ را مشخص کنید.",
      "برای اعمال بازه انتخاب‌شده، روی «اعمال فیلتر» بزنید.",
      "شماره فاکتور برگشتی قابل انتخاب است و با کلیک روی آن وارد جزئیات اقلام همان فاکتور می‌شوید.",
      "در صفحات دارای صفحه‌بندی، از دکمه‌های پایین جدول برای جابه‌جایی بین صفحات استفاده کنید.",
    ],
    tips: ["اگر فاکتور موردنظر در فهرست نیست، ابتدا بازه تاریخ را بررسی و دوباره فیلتر را اعمال کنید."],
  },
  {
    id: "sales-report",
    title: "گزارش خرید",
    icon: FaChartLine,
    summary: "برای دیدن تصویر کلی از خرید، روند رشد، وزن خرید و ترکیب گروه‌های محصولی استفاده می‌شود.",
    bullets: [
      "در بالای صفحه می‌توانید «گروه محصول» را انتخاب کنید تا گزارش بر اساس همان گروه نمایش داده شود.",
      "شاخص‌هایی مانند خالص ریال خرید ماه جاری و قبل، درصد رشد، وزن خرید و تعداد فاکتورها نمایش داده می‌شوند.",
      "در بخش محصولات، کالاهایی که در ماه جاری خرید نشده‌اند به‌صورت فهرست نمایش داده می‌شوند.",
      "نمودار تفکیک خرید گروه محصولی، سهم گروه‌های مختلف از خرید را به‌شکل دیداری نشان می‌دهد.",
    ],
    tips: ["برای تحلیل بهتر، ابتدا گروه محصول را انتخاب کنید و سپس شاخص‌های همان گروه را با ماه قبل مقایسه کنید."],
  },
  {
    id: "catalog",
    title: "کاتالوگ محصول",
    icon: FaShoppingBag,
    summary: "تصاویر و فهرست محصولات را با امکان انتخاب دسته و جستجو مشاهده کنید.",
    bullets: [
      "دسته‌بندی محصول را از فهرست انتخاب کنید تا محصولات همان گروه نمایش داده شوند.",
      "در کادر «جستجو...» نام محصول موردنظر را وارد کنید.",
      "لیست محصولات به‌صورت تدریجی بارگذاری می‌شود؛ با پایین رفتن در صفحه، محصولات بیشتری نمایش داده خواهند شد.",
      "اگر تصویر محصول در دسترس نباشد، تصویر پیش‌فرض نمایش داده می‌شود.",
    ],
    tips: ["برای پیدا کردن سریع یک محصول، ابتدا دسته مناسب را انتخاب کنید و سپس نام یا بخشی از نام آن را جستجو کنید."],
  },
  {
    id: "complaints",
    title: "اعلانات و شکایات",
    icon: FaBullhorn,
    summary: "برای مشاهده درخواست‌های قبلی، ثبت درخواست جدید و پیگیری وضعیت آن‌ها استفاده می‌شود.",
    bullets: [
      "در فهرست، شماره درخواست، گروه درخواست، تاریخ ایجاد و وضعیت آن نمایش داده می‌شود.",
      "برای دیدن جزئیات یک درخواست، روی شماره درخواست کلیک کنید.",
      "برای ایجاد درخواست جدید روی «ثبت درخواست» بزنید، دسته‌بندی موضوع را انتخاب کنید و شرح موضوع را کامل بنویسید.",
      "در صورت امکان شماره فاکتور یا شماره حواله مرتبط را در متن درخواست ذکر کنید تا رسیدگی سریع‌تر انجام شود.",
      "اطلاعات تماس واحد رسیدگی نیز در همین صفحه در دسترس است.",
    ],
    tips: ["شرح دقیق و روشن مشکل، همراه با شماره فاکتور یا حواله مرتبط، باعث می‌شود درخواست سریع‌تر بررسی شود."],
  },
  {
    id: "contact",
    title: "ارتباط با ما",
    icon: FaHeadset,
    summary: "راه‌های ارتباط با شعب و واحدهای مرتبط را روی نقشه و در فهرست اطلاعات مشاهده کنید.",
    bullets: [
      "از فهرست یا کنترل انتخاب شعبه برای پیدا کردن شعبه موردنظر استفاده کنید.",
      "با انتخاب یک شعبه، نقشه روی موقعیت آن تمرکز می‌کند و اطلاعات شعبه در ادامه نمایش داده می‌شود.",
      "برای دیدن نمای کلی، گزینه «همه شعب» را انتخاب کنید.",
      "اطلاعاتی مانند آدرس، کدپستی در صورت وجود و شماره‌های تماس نمایش داده می‌شوند.",
    ],
    tips: ["اگر به دنبال یک شعبه خاص هستید، به‌جای جابه‌جایی دستی روی نقشه، آن را از فهرست انتخاب کنید."],
  },
  {
    id: "password",
    title: "تغییر / بازیابی رمز عبور",
    icon: FaShieldAlt,
    summary: "برای تغییر رمز عبور یا بازیابی رمز فراموش‌شده از مسیرهای مربوط به ورود استفاده کنید.",
    bullets: [
      "برای تغییر رمز در زمان ورود به حساب، از منوی کاربر گزینه «تغییر رمز عبور» را انتخاب کنید.",
      "اگر رمز خود را فراموش کرده‌اید، از صفحه ورود گزینه بازیابی رمز عبور را انتخاب کنید.",
      "در فرآیند بازیابی، شماره موبایل و کد تأیید را وارد کرده و سپس رمز جدید را ثبت کنید.",
    ],
    warning: "کد تأیید و رمز جدید خود را در اختیار دیگران قرار ندهید.",
  },
];

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const HighlightedText = ({ children, search }) => {
  const term = search.trim();
  if (!term || typeof children !== "string") return children;

  const parts = children.split(new RegExp(`(${escapeRegExp(term)})`, "gi"));
  return parts.map((part, index) =>
    part.toLowerCase() === term.toLowerCase() ? (
      <mark key={index} className="guide-search-highlight">{part}</mark>
    ) : (
      <React.Fragment key={index}>{part}</React.Fragment>
    )
  );
};

const GuideSection = ({ section, open, onToggle, search }) => {
  const Icon = section.icon;
  return (
    <article id={section.id} className="guide-card bg-white rounded-2xl shadow-md border border-blue-100 overflow-hidden scroll-mt-24">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-4 px-5 py-4 text-right hover:bg-blue-50/60 transition"
        aria-expanded={open}
      >
        <div className="flex items-center gap-3 min-w-0">
          <span className="w-10 h-10 rounded-xl bg-blue-50 text-blue-700 flex items-center justify-center shrink-0">
            <Icon />
          </span>
          <div className="min-w-0">
            <h2 className="text-base sm:text-lg font-bold text-blue-800"><HighlightedText search={search}>{section.title}</HighlightedText></h2>
            <p className="text-xs sm:text-sm text-gray-500 mt-1 leading-6"><HighlightedText search={search}>{section.summary}</HighlightedText></p>
          </div>
        </div>
        <span className="text-blue-700 shrink-0">{open ? <FaChevronUp /> : <FaChevronDown />}</span>
      </button>

      {open && (
        <div className="px-5 pb-5 border-t border-blue-50">
          <div className="pt-4 space-y-2">
            <h3 className="font-bold text-blue-700 text-sm">نحوه استفاده</h3>
            <ul className="list-disc pr-5 space-y-2 text-sm text-gray-700 leading-7">
              {section.bullets.map((bullet, index) => (
                <li key={index}><HighlightedText search={search}>{bullet}</HighlightedText></li>
              ))}
            </ul>
          </div>

          {section.tips?.length > 0 && (
            <div className="mt-4 rounded-xl bg-emerald-50 border border-emerald-100 p-3 text-sm text-emerald-900 leading-7">
              <div className="flex items-center gap-2 font-bold mb-1"><FaInfoCircle /> نکته کاربردی</div>
              {section.tips.map((tip, index) => (
                <p key={index}><HighlightedText search={search}>{tip}</HighlightedText></p>
              ))}
            </div>
          )}

          {section.warning && (
            <div className="mt-3 rounded-xl bg-amber-50 border border-amber-200 p-3 text-sm text-amber-900 leading-7">
              <div className="flex items-center gap-2 font-bold mb-1"><FaExclamationTriangle /> نکته مهم</div>
              <p><HighlightedText search={search}>{section.warning}</HighlightedText></p>
            </div>
          )}
        </div>
      )}
    </article>
  );
};

const GuidePage = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [openSections, setOpenSections] = useState(() => GUIDE_SECTIONS.reduce((acc, item) => ({ ...acc, [item.id]: true }), {}));

  const filteredSections = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return GUIDE_SECTIONS;
    return GUIDE_SECTIONS.filter((section) =>
      [section.title, section.summary, ...section.bullets, ...(section.tips || []), section.warning || ""]
        .join(" ")
        .toLowerCase()
        .includes(term)
    );
  }, [search]);

  const toggleSection = (id) => {
    setOpenSections((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const expandAll = () => {
    setOpenSections(GUIDE_SECTIONS.reduce((acc, item) => ({ ...acc, [item.id]: true }), {}));
  };

  const collapseAll = () => {
    setOpenSections(GUIDE_SECTIONS.reduce((acc, item) => ({ ...acc, [item.id]: false }), {}));
  };

  return (
    <DashboardLayout>
      <div className="guide-page py-2" dir="rtl">
        <div className="guide-toolbar flex flex-col lg:flex-row gap-4 items-stretch lg:items-center justify-between mb-5">
          <div>
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-xl bg-blue-700 text-white flex items-center justify-center shadow-sm">
                <FaBookOpen />
              </div>
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-blue-800">راهنمای استفاده از پنل</h1>
                <p className="text-xs sm:text-sm text-gray-500 mt-1">همه بخش‌ها به زبان ساده و با تمرکز بر نحوه استفاده توضیح داده شده‌اند.</p>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            <button onClick={() => navigate("/dashboard")} className="px-4 py-2 bg-white border border-blue-200 text-blue-700 hover:bg-blue-50 text-sm rounded-lg flex items-center gap-2">
              <FaArrowLeft /> بازگشت
            </button>
          </div>
        </div>

        <div className="guide-note mb-5 rounded-2xl bg-blue-50 border border-blue-100 p-4 text-sm text-blue-900 leading-7">
          <div className="flex items-start gap-2">
            <FaInfoCircle className="mt-1 shrink-0" />
            <p>این راهنما برای استفاده روزمره نوشته شده است. هرجا انجام یک کار نیاز به کلیک، انتخاب تاریخ، جستجو یا مشاهده جزئیات دارد، مسیر انجام آن به‌صورت مرحله‌ای توضیح داده شده است.</p>
          </div>
        </div>

        <div className="grid lg:grid-cols-[260px_minmax(0,1fr)] gap-5 items-start">
          <aside className="guide-sidebar lg:sticky lg:top-5 bg-white rounded-2xl shadow-md border border-blue-100 p-4">
            <div className="flex items-center gap-2 text-blue-800 font-bold mb-3"><FaClipboardList /> دسترسی سریع</div>
            <div className="relative mb-3">
              <FaSearch className="absolute right-3 top-3 text-gray-400 text-sm" />
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="جستجو در راهنما..."
                className="w-full border rounded-lg pr-9 pl-3 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-blue-100"
              />
            </div>
            <div className="flex gap-2 mb-3">
              <button onClick={expandAll} className="flex-1 text-xs bg-blue-50 text-blue-700 rounded-lg py-2 hover:bg-blue-100">باز کردن همه</button>
              <button onClick={collapseAll} className="flex-1 text-xs bg-gray-50 text-gray-600 rounded-lg py-2 hover:bg-gray-100">بستن همه</button>
            </div>
            <nav className="space-y-1 max-h-[60vh] overflow-y-auto guide-nav">
              {filteredSections.map((section) => {
                const Icon = section.icon;
                return (
                  <a key={section.id} href={`#${section.id}`} className="flex items-center gap-2 text-xs text-gray-700 hover:text-blue-700 hover:bg-blue-50 rounded-lg px-2 py-2 leading-5">
                    <Icon className="text-blue-500 shrink-0" />
                    <span>{section.title}</span>
                  </a>
                );
              })}
            </nav>
          </aside>

          <main className="space-y-4">
            {filteredSections.length > 0 ? (
              filteredSections.map((section) => (
                <GuideSection
                  key={section.id}
                  section={section}
                  search={search}
                  open={search.trim() ? true : openSections[section.id] !== false}
                  onToggle={() => toggleSection(section.id)}
                />
              ))
            ) : (
              <div className="bg-white rounded-2xl shadow-md border border-blue-100 p-10 text-center text-gray-500">
                نتیجه‌ای برای «{search}» پیدا نشد.
              </div>
            )}
          </main>
        </div>

        <div className="guide-print-footer hidden">راهنمای استفاده از پنل مشتریان</div>
      </div>
    </DashboardLayout>
  );
};

export default GuidePage;
